import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration from config module

/**
 * Class representing a view for the third betting shop products table.
 * @extends JetView
 */
export default class tableProductsThirdBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define a datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatableProductThird',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Conditional vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Set height based on screen width
            height: screen.width < 820 ? 410 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: 'Editar',
                    // Template function to render the edit icon based on permissions
                    template: function(obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingProductsThirdBetShopEdit', 'Edit')) {
                            // Return edit icon if permission is granted
                            return '<span class=\'webix_icon wxi-close edit\'></span>';
                        } else {
                            // Return empty string if permission is denied
                            return '';
                        }
                    },
                },
                // Column for product ID
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for product name with localization
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' },
                // Column for provider name with localization
                {
                    id: 'Provider',
                    header: _('Proveedor'),
                    width: 150,
                    sort: 'int',
                },
                // Column for product state with editor as combo
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the state combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
                // Column for income accounting account with combo editor
                {
                    id: 'Account',
                    header: _('Cuenta Contable Ingreso'),
                    editor: 'combo',
                    options: [],
                    width: 150,
                    sort: 'int',
                },
                // Column for expense accounting account with combo editor
                {
                    id: 'AccountExpenses',
                    header: _('Cuenta Contable Egreso'),
                    editor: 'combo',
                    options: [],
                    width: 150,
                    sort: 'int',
                },
                // Column for internal product status with combo editor
                {
                    id: 'InternalProducts',
                    header: _('Producto Interno?'),
                    editor: 'combo',
                    // Options for internal product status
                    options: [
                        { id: 1, value: _('Sí') },
                        { id: 2, value: _('No') },
                    ],
                    width: 100,
                    sort: 'int',
                },
                // Column for internal product type with combo editor
                {
                    id: 'TypeInternal',
                    header: _('Tipo Interno'),
                    editor: 'combo',
                    // Options for internal product types
                    options: [
                        {
                            id: 59,
                            value: _('Plan cuentas Apuestas Tickets Tiendas'),
                        },
                        {
                            id: 60,
                            value: _('Plan cuentas Premios Tickets Tiendas'),
                        },
                        {
                            id: 61,
                            value: _('Plan cuentas Pagos notas de retiro'),
                        },
                        { id: 62, value: _('Plan de cuentas Recargas') },
                    ],
                    width: 200,
                    sort: 'int',
                },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function(euv, id) {
                    // Trigger the event to open the edit product dialog
                    vthis.app.callEvent('openEditProductThird', [{}]);
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // API URL for fetching product data
            url: devConfig.geturlApi() + 'Accounting/GetProductsThird',
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Getting localization service
        var url = grid.data.url; // URL for data grid
        var filter = ''; // Filter string for data retrieval
        var datePopup = []; // Array to hold provider data for the popup
        var datePopup2 = []; // Array to hold account data for the popup
        var popup = ''; // Variable to hold the edit product popup
        var popupAdd = ''; // Variable to hold the add product popup

        webix
            .ajax() // Initiating an AJAX request
            .headers({
                'Content-type': 'application/json', // Setting content type to JSON
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProvidersSelect', '', { // POST request to get providers
                error: function(text, data, XmlHttpRequest) { // Error callback
                    webix.message(_('Error! ')); // Display error message
                },
                success: function(text, data, XmlHttpRequest) { // Success callback
                    var resp = JSON.parse(text); // Parsing response text to JSON
                    datePopup = resp.Data; // Storing provider data in datePopup
                    webix
                        .ajax() // Initiating another AJAX request
                        .headers({
                            'Content-type': 'application/json', // Setting content type to JSON
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetAccountsSelect', '', { // POST request to get accounts
                            error: function(text, data, XmlHttpRequest) { // Error callback
                                webix.message(_('Error! ')); // Display error message
                            },
                            success: function(text, data, XmlHttpRequest) { // Success callback
                                var resp = JSON.parse(text); // Parsing response text to JSON
                                datePopup2 = resp.Data; // Storing account data in datePopup2
                                popup = webix.ui({ // Creating the edit product popup
                                    view: 'window',
                                    id: 'EditProductThird',
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Editar Producto Tercero'), // Label for editing product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function() { // Click event to close the popup
                                                    this.getTopParentView().hide(); // Hiding the popup
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centering the popup
                                    modal: true, // Making the popup modal
                                    body: {
                                        view: 'form',
                                        id: 'editForm', // ID for the edit form
                                        elements: [
                                            {
                                                view: 'text',
                                                label: 'ID', // Label for ID field
                                                name: 'Id', // Name for ID field
                                                readonly: true, // Making ID field read-only
                                            },
                                            {
                                                view: 'text',
                                                label: _('Nombre'), // Label for Name field
                                                name: 'Name', // Name for Name field
                                                readonly: true, // Making Name field read-only
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Estado'), // Label for State field
                                                name: 'State', // Name for State field
                                                options: [ // Options for State field
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active state
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive state
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Proveedor'), // Label for Provider field
                                                name: 'Provider', // Name for Provider field
                                                readonly: true, // Making Provider field read-only
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cuenta Contable Ingreso'), // Label for Income Account field
                                                name: 'Account', // Name for Income Account field
                                                readonly: true, // Making Income Account field read-only
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cuenta Contable Egreso'), // Label for Expense Account field
                                                name: 'AccountExpenses', // Name for Expense Account field
                                                readonly: true, // Making Expense Account field read-only
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Producto Interno?'), // Label for Internal Product field
                                                name: 'InternalProducts', // Name for Internal Product field
                                                options: [ // Options for Internal Product field
                                                    {
                                                        id: 1,
                                                        value: _('Sí'), // Yes option
                                                    },
                                                    {
                                                        id: 2,
                                                        value: _('No'), // No option
                                                    },
                                                ],
                                                required: true, // Making this field required
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Tipo Interno'), // Label for Internal Type field
                                                name: 'TypeInternal', // Name for Internal Type field
                                                options: [ // Options for Internal Type field
                                                    {
                                                        id: '',
                                                        value: _('Ninguno seleccionado'), // No selection option
                                                    },
                                                    {
                                                        id: 59,
                                                        value: _('Plan cuentas Apuestas Tickets Tiendas'), // Specific internal type
                                                    },
                                                    {
                                                        id: 60,
                                                        value: _('Plan cuentas Premios Tickets Tiendas'), // Specific internal type
                                                    },
                                                    {
                                                        id: 61,
                                                        value: _('Plan cuentas Pagos notas de retiro'), // Specific internal type
                                                    },
                                                    {
                                                        id: 62,
                                                        value: _('Plan de cuentas Recargas'), // Specific internal type
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [ // Button layout
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button
                                                        click: function() { // Click event for cancel button
                                                            this.getTopParentView().hide(); // Hiding the popup
                                                           $$('editForm').setValues($$('editForm').getCleanValues()); // Resetting form values
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Guardar'), // Save button
                                                        click: function($e) { // Click event for save button
                                                            var values =$$('editForm').getValues(); // Getting form values
                                                            webix
                                                                .ajax() // Initiating AJAX request to save product
                                                                .headers({
                                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                    'Accounting/SaveProductsThird',
                                                                    '{"Id":"' +
                                                                    values.Id +
                                                                    '", "Name":"' +
                                                                    values.Name +
                                                                    '", "Provider":"' +
                                                                    values.Provider +
                                                                    '" , "Account":"' +
                                                                    values.Account +
                                                                    '" , "AccountExpenses":"' +
                                                                    values.AccountExpenses +
                                                                    '" , "State":"' +
                                                                    values.State +
                                                                    '", "InternalProducts":"' +
                                                                    values.InternalProducts +
                                                                    '", "TypeInternal":"' +
                                                                    values.TypeInternal +
                                                                    '"}', // Sending product data as JSON
                                                                    {
                                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                                            webix.message(_('Error! ')); // Display error message
                                                                        },
                                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                                            webix.message(_('Producto Tercero Actualizado')); // Display success message
                                                                            grid.clearAll(); // Clearing the grid
                                                                            grid.load( // Reloading the grid with updated data
                                                                                url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter,
                                                                            );
                                                                        },
                                                                    },
                                                                );
                                                           $$('editForm').setValues($$('editForm').getCleanValues()); // Resetting form values
                                                            this.getTopParentView().hide(); // Hiding the popup
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                });
                                popupAdd = webix.ui({ // Creating the add product popup
                                    view: 'window',
                                    id: 'AddProductThird',
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Añadir Producto Tercero'), // Label for adding product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function() { // Click event to close the popup
                                                    this.getTopParentView().hide(); // Hiding the popup
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centering the popup
                                    modal: true, // Making the popup modal
                                    body: {
                                        view: 'form',
                                        id: 'addformProductThid', // ID for the add form
                                        elements: [
                                            {
                                                view: 'text',
                                                label: _('Nombre'), // Label for Name field
                                                name: 'Name', // Name for Name field
                                                required: true, // Making this field required
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Proveedor'), // Label for Provider field
                                                name: 'Provider', // Name for Provider field
                                                options: datePopup, // Options populated from datePopup
                                                required: true, // Making this field required
                                                labelWidth: 100, // Setting label width
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Estado'), // Label for State field
                                                name: 'State', // Name for State field
                                                options: [ // Options for State field
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active state
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive state
                                                    },
                                                ],
                                                required: true, // Making this field required
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cuenta Contable Ingreso'), // Label for Income Account field
                                                name: 'Account', // Name for Income Account field
                                                options: datePopup2, // Options populated from datePopup2
                                                required: true, // Making this field required
                                                labelWidth: 100, // Setting label width
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cuenta Contable Egreso'), // Label for Expense Account field
                                                name: 'AccountExpenses', // Name for Expense Account field
                                                options: datePopup2, // Options populated from datePopup2
                                                required: true, // Making this field required
                                                labelWidth: 100, // Setting label width
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Producto Interno?'), // Label for Internal Product field
                                                name: 'InternalProducts', // Name for Internal Product field
                                                options: [ // Options for Internal Product field
                                                    {
                                                        id: 1,
                                                        value: _('Sí'), // Yes option
                                                    },
                                                    {
                                                        id: 2,
                                                        value: _('No'), // No option
                                                    },
                                                ],
                                                required: true, // Making this field required
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Tipo Interno'), // Label for Internal Type field
                                                name: 'TypeInternal', // Name for Internal Type field
                                                options: [ // Options for Internal Type field
                                                    {
                                                        id: '',
                                                        value: _('Ninguno seleccionado'), // No selection option
                                                    },
                                                    {
                                                        id: 59,
                                                        value: _('Plan cuentas Apuestas Tickets Tiendas'), // Specific internal type
                                                    },
                                                    {
                                                        id: 60,
                                                        value: _('Plan cuentas Premios Tickets Tiendas'), // Specific internal type
                                                    },
                                                    {
                                                        id: 61,
                                                        value: _('Plan cuentas Pagos notas de retiro'), // Specific internal type
                                                    },
                                                    {
                                                        id: 62,
                                                        value: _('Plan de cuentas Recargas'), // Specific internal type
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [ // Button layout
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button
                                                        click: function() { // Click event for cancel button
                                                            this.getTopParentView().hide(); // Hiding the popup
                                                            $$('addformProductThid').setValues( // Resetting form values
                                                                $$('addformProductThid').getCleanValues(),
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Guardar'), // Save button
                                                        click: function($e) { // Click event for save button
                                                            var values = $$('addformProductThid').getValues(); // Getting form values
                                                            if ($$('addformProductThid').validate()) { // Validating form
                                                                webix
                                                                    .ajax() // Initiating AJAX request to save product
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Setting content type to JSON
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                        'Accounting/SaveProductsThird',
                                                                        '{"Name":"' +
                                                                        values.Name +
                                                                        '", "State":"' +
                                                                        values.State +
                                                                        '", "Provider":"' +
                                                                        values.Provider +
                                                                        '",  "Account":"' +
                                                                        values.Account +
                                                                        '",  "AccountExpenses":"' +
                                                                        values.AccountExpenses +
                                                                        '", "InternalProducts":"' +
                                                                        values.InternalProducts +
                                                                        '", "TypeInternal":"' +
                                                                        values.TypeInternal +
                                                                        '"}', // Sending product data as JSON
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) { // Error callback
                                                                                webix.message(_('Error! ')); // Display error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) { // Success callback
                                                                                webix.message(_('Producto Tercero Agregado')); // Display success message
                                                                                grid.clearAll(); // Clearing the grid
                                                                                grid.load( // Reloading the grid with updated data
                                                                                    url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter,
                                                                                );
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addformProductThid').setValues( // Resetting form values
                                                                    $$('addformProductThid').getCleanValues(),
                                                                );
                                                                this.getTopParentView().hide(); // Hiding the popup
                                                            } else {
                                                                webix.message({ // Displaying validation error message
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _('Completa los campos...'), // Prompting to complete fields
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function() { // Change event for form elements
                                                    this.validate(); // Validating form on change
                                                },
                                            },
                                        },
                                    },
                                });
                               $$('editForm').bind($$('datatableProductThird')); // Binding edit form to data table
                            },
                        });
                },
            });

        // Event listener for 'productThird:filter' event on the app instance
        this.on(this.app, 'productThird:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string for URL parameters

            // Iterate over each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query string
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate over each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create Date object from value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query string
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create Date object from value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            // Load new data into the grid with constructed URL and parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load data into the grid after sorting, with pagination and sorting parameters
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Current page size for pagination
                filter + // Additional filter parameters
                '&sort[' +
                by + // Sort by the specified column
                ']=' +
                dir, // Sort direction (ascending/descending)
            );
        });

        // Listen for the 'addProductThird:button' event from the application
        this.on(this.app, 'addProductThird:button', (filter) => {
            // Check if both datePopup and datePopup2 have values
            if (datePopup.length > 0 && datePopup2.length > 0) {
                $$('addformProductThid').clearValidation(); // Clear any previous validation errors
                popupAdd.show(); // Show the add product popup
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message to display
                });
            }
        });

        // Listen for the 'openEditProductThird' event from the application
        this.on(this.app, 'openEditProductThird', (filterData) => {
            // Check if datePopup has values
            if (datePopup.length > 0) {
                popup.show(); // Show the edit product popup
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message to display
                });
            }
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
